<div class="w-full relative">
    <input [disabled]="disabled" type="number" class="styled dark pr-12" [(ngModel)]="value" (ngModelChange)="changedValue()">
    <div *ngIf="currency && !disabled" class="absolute right-0 vertical-center mr-1 pr-2 font-bold bg-gray-100 cursor-pointer" [matMenuTriggerFor]="currencyMenu">
        {{ currency.symbol }}
        <span class="iconify inline" data-icon="entypo:chevron-small-down"></span>
    </div>
    <div *ngIf="currency && disabled" class="absolute right-0 vertical-center mr-1 pr-2 font-bold bg-gray-100 text-gray-500">
        {{ currency.symbol }}
    </div>
</div>
<div *ngIf="currency && currency.code != 'EUR'" class="text-xs text-gray-400">Entspricht {{ value / currency.exchangeRate | currency: 'EUR' }}</div>
<mat-menu #currencyMenu>
    <div (click)="currency = curr;changedCurrency()" class="py-2 px-2 text-sm cursor-pointer hover:bg-blue-100" *ngFor="let curr of (currencies$ | async)">
        {{ curr.name }}
    </div>
</mat-menu>
